import { BODY_SM_SM_MEDIUM_STYLES } from '@constants/text.ts';
import { styled } from 'styled-components';

export const TabBarWrapper = styled.div`
    display: flex;
    gap: var(--spacing-2xs, 4px);
    cursor: pointer;
    text-align: center;
    background: #f2f8fd;
    padding: var(--spacing-2xs, 4px);
    margin: 16px 0;
`;

export const ActiveTab = styled.div`
    flex: 1;
    padding: var(--spacing-2xs, 4px);
    border-radius: var(--border-radius-s_8, 8px);
    background: var(--colors-surface-action, #2171c6);
    ${BODY_SM_SM_MEDIUM_STYLES};
    color: var(--colors-text-on-action, #fff);
    line-height: 175%;
`;

export const InactiveTab = styled.div`
    flex: 1;
    padding: var(--spacing-2xs, 4px);
    border-radius: var(--border-radius-s_8, 8px);
    background: var(--colors-surface-primary, #fff);
    ${BODY_SM_SM_MEDIUM_STYLES};
    color: var(--colors-text-on-disabled, #70768d);
    line-height: 175%;
`;
